export default {
    path: '/tooling',
    component: () => import('@/views/layout.vue'),
    redirect: '/tooling',
    name: 'tooling',
    sort: 7,
    icon: 'el-icon-s-tools',
    meta: { title: '工装及仪器管理' , authCode: ['TOOL001'] },
    children: [
        {
            path: '/toolingInfo',
            name: 'toolingInfo',
            component: () => import('@/views/permission/tooling/toolingInfo.vue'),
            meta: {
                keepAlive: true,
                title: '工装及仪器台账',
                authCode: ['TOOLINFO001']
            }
        },
        {
            path: '/toolingClassify',
            name: 'toolingClassify',
            component: () => import('@/views/permission/tooling/toolingClassify.vue'),
            meta: {
                title: '工装及仪器类型',
                authCode: ['TOOLTYPE001']
            }
        },
        {
            path: '/addlingInfo',
            name: 'addlingInfo',
            hidden: true,
            component: () => import('@/views/permission/tooling/addlingInfo.vue'),
            meta: {
                title: '编辑工装',
            }
        }
    ]
}
